import { User } from 'lucide-react';
import { useUsuariosEmpresa } from './useUsuariosEmpresa';

interface Props {
  session: any;
  value: string | null | undefined;
  onChange: (id: string | null) => void;
  label?: string;
  className?: string;
}

const ResponsavelPicker = ({ session, value, onChange, label = 'Responsável', className = '' }: Props) => {
  const usuarios = useUsuariosEmpresa(session);
  return (
    <div className={className}>
      {label && <label className="text-xs text-gray-600 flex items-center gap-1"><User className="h-3 w-3" /> {label}</label>}
      <select value={value || ''} onChange={e => onChange(e.target.value || null)}
        className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-lg text-sm bg-white">
        <option value="">— Sem responsável —</option>
        {usuarios.map(u => (
          <option key={u._id} value={u.email}>{u.nome || u.email}</option>
        ))}
      </select>
    </div>
  );
};

export default ResponsavelPicker;
